import { render, staticRenderFns } from "./covidAnswers.vue?vue&type=template&id=5b457a56&"
import script from "./covidAnswers.vue?vue&type=script&lang=js&"
export * from "./covidAnswers.vue?vue&type=script&lang=js&"
import style0 from "./covidAnswers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports